// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YeGi","colBig":"styles_colBig__xv2eQ","colSmall":"styles_colSmall__XbORy"};